var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "cardDivTV" } },
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary", fixed: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "", disabled: _vm.btnBloquear },
                      on: {
                        click: function($event) {
                          !_vm.esEdicion
                            ? _vm.closeModal(false)
                            : (_vm.dialogConfirmacionClose = true)
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _c("v-toolbar-title", [
                    _vm._v(
                      _vm._s(
                        _vm.esEdicion ? "Editar Módulo" : "Ver Detalle Módulo"
                      )
                    )
                  ]),
                  _c("v-spacer"),
                  _c(
                    "v-toolbar-items",
                    [
                      _vm.esEdicion
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "btn-grabar",
                              attrs: {
                                depressed: "",
                                disabled:
                                  !_vm.validForm || _vm.btnBloquear
                                    ? true
                                    : false
                              },
                              on: {
                                click: function($event) {
                                  return _vm.grabarEdicion()
                                }
                              }
                            },
                            [_vm._v("Guardar Cambios")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c("br"),
              _c("br"),
              _c("br"),
              _c(
                "div",
                [
                  _c(
                    "v-card",
                    { attrs: { height: "55px", flat: "" } },
                    [
                      _c(
                        "v-bottom-nav",
                        {
                          attrs: {
                            active: _vm.bottomNav,
                            value: true,
                            absolute: "",
                            color: "transparent"
                          },
                          on: {
                            "update:active": function($event) {
                              _vm.bottomNav = $event
                            }
                          }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    (_vm.informacionGeneral.visible &&
                                      _vm.esEdicion) ||
                                    (_vm.informacionGeneralVerDetalle.visible &&
                                      !_vm.esEdicion),
                                  expression:
                                    "\n                (informacionGeneral.visible && esEdicion) ||\n                  (informacionGeneralVerDetalle.visible && !esEdicion)\n              "
                                }
                              ],
                              attrs: {
                                color: "primary",
                                flat: "",
                                value: _vm.informacionGeneral.step
                              }
                            },
                            [
                              _c("span", [_vm._v("Información General")]),
                              _c("v-icon", [_vm._v("info")])
                            ],
                            1
                          ),
                          _c(
                            "v-btn",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    (_vm.asociarAcciones.visible &&
                                      _vm.esEdicion) ||
                                    (_vm.asociarAccionesVerDetalle.visible &&
                                      !_vm.esEdicion),
                                  expression:
                                    "\n                (asociarAcciones.visible && esEdicion) ||\n                  (asociarAccionesVerDetalle.visible && !esEdicion)\n              "
                                }
                              ],
                              attrs: {
                                color: "primary",
                                flat: "",
                                value: _vm.asociarAcciones.step
                              },
                              on: { click: _vm.cierraMenu }
                            },
                            [
                              _c("span", [_vm._v("Asociar Acciones")]),
                              _c("v-icon", [_vm._v("note_add")])
                            ],
                            1
                          ),
                          _c(
                            "v-btn",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    (_vm.asociarSubAcciones.visible &&
                                      _vm.esEdicion &&
                                      this.CheckSeleccionados.length > 0) ||
                                    (_vm.asociarSubAccionesVerDetalle.visible &&
                                      !_vm.esEdicion &&
                                      this.CheckSeleccionados.length > 0),
                                  expression:
                                    "\n                (asociarSubAcciones.visible &&\n                  esEdicion &&\n                  this.CheckSeleccionados.length > 0) ||\n                  (asociarSubAccionesVerDetalle.visible &&\n                    !esEdicion &&\n                    this.CheckSeleccionados.length > 0)\n              "
                                }
                              ],
                              attrs: {
                                color: "primary",
                                flat: "",
                                value: _vm.asociarSubAcciones.step
                              },
                              on: { click: _vm.cierraMenu }
                            },
                            [
                              _c("span", [_vm._v("Asociar Subacciones")]),
                              _c("v-icon", [_vm._v("add_to_photos")])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.bottomNav == _vm.informacionGeneral.step &&
                            ((_vm.informacionGeneral.visible &&
                              _vm.esEdicion) ||
                              (_vm.informacionGeneralVerDetalle.visible &&
                                !_vm.esEdicion)),
                          expression:
                            "\n            bottomNav == informacionGeneral.step &&\n              ((informacionGeneral.visible && esEdicion) ||\n                (informacionGeneralVerDetalle.visible && !esEdicion))\n          "
                        }
                      ],
                      staticClass: "cardnew",
                      attrs: { align: "center" }
                    },
                    [
                      _c("br"),
                      _c(
                        "v-flex",
                        { attrs: { md10: "" } },
                        [
                          _c(
                            "v-card",
                            { staticClass: "rounded-card" },
                            [
                              _c(
                                "v-form",
                                {
                                  ref: "form",
                                  staticClass: "col-md-12",
                                  attrs: { "lazy-validation": "" },
                                  model: {
                                    value: _vm.validForm,
                                    callback: function($$v) {
                                      _vm.validForm = $$v
                                    },
                                    expression: "validForm"
                                  }
                                },
                                [
                                  _c(
                                    "v-container",
                                    { attrs: { "grid-list-md": "" } },
                                    [
                                      _c(
                                        "div",
                                        { attrs: { align: "left" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { md12: "" } },
                                            [
                                              _c(
                                                "h2",
                                                {
                                                  staticClass: "h2_title",
                                                  staticStyle: {
                                                    "margin-top":
                                                      "12px!important"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        Información General\n                      "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _c("v-divider"),
                                      _c("br"),
                                      _c(
                                        "v-layout",
                                        { attrs: { wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                sm12: "",
                                                md12: ""
                                              }
                                            },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "Código",
                                                  counter: 80,
                                                  type: "text",
                                                  disabled: true
                                                },
                                                model: {
                                                  value: _vm.editedItem.id,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.editedItem,
                                                      "id",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "editedItem.id"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                sm12: "",
                                                md12: ""
                                              }
                                            },
                                            [
                                              _c("v-text-field", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value:
                                                      "required|ModuloNombreUnicoEditar|max:80",
                                                    expression:
                                                      "'required|ModuloNombreUnicoEditar|max:80'"
                                                  }
                                                ],
                                                attrs: {
                                                  "error-messages": _vm.errors.collect(
                                                    "nombre"
                                                  ),
                                                  "data-vv-name": "nombre",
                                                  label: "Nombre",
                                                  type: "text",
                                                  counter: 80,
                                                  disabled: !_vm.esEdicion,
                                                  required: ""
                                                },
                                                model: {
                                                  value: _vm.editedItem.nombre,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.editedItem,
                                                      "nombre",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "editedItem.nombre"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                sm12: "",
                                                md12: ""
                                              }
                                            },
                                            [
                                              _c("v-text-field", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "max:200",
                                                    expression: "'max:200'"
                                                  }
                                                ],
                                                attrs: {
                                                  "error-messages": _vm.errors.collect(
                                                    "descripcion"
                                                  ),
                                                  "data-vv-name": "descripcion",
                                                  label: "Descripción",
                                                  type: "text",
                                                  counter: 200,
                                                  disabled: !_vm.esEdicion
                                                },
                                                model: {
                                                  value:
                                                    _vm.editedItem.descripcion,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.editedItem,
                                                      "descripcion",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "editedItem.descripcion"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.bottomNav == _vm.asociarAcciones.step &&
                            ((_vm.asociarAcciones.visible && _vm.esEdicion) ||
                              (_vm.asociarAccionesVerDetalle.visible &&
                                !_vm.esEdicion)),
                          expression:
                            "\n            bottomNav == asociarAcciones.step &&\n              ((asociarAcciones.visible && esEdicion) ||\n                (asociarAccionesVerDetalle.visible && !esEdicion))\n          "
                        }
                      ],
                      staticClass: "cardnew",
                      attrs: { align: "center" }
                    },
                    [
                      _c("br"),
                      _c(
                        "v-flex",
                        { attrs: { md10: "" } },
                        [
                          _c(
                            "v-card",
                            { staticClass: "rounded-card" },
                            [
                              _c(
                                "v-container",
                                {
                                  attrs: {
                                    "grid-list-md": "",
                                    "text-xs-center": ""
                                  }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c(
                                        "div",
                                        { attrs: { align: "left" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { md12: "" } },
                                            [
                                              _c(
                                                "h2",
                                                { staticClass: "h2_title" },
                                                [_vm._v("Asociar Acciones")]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _c("v-divider"),
                                  _c("br"),
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { md6: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Buscar...",
                                              "prepend-icon": "lock_open",
                                              "append-icon": "search"
                                            },
                                            on: {
                                              input: _vm.onFilterTextBoxChanged
                                            },
                                            model: {
                                              value: _vm.buscarAccion,
                                              callback: function($$v) {
                                                _vm.buscarAccion = $$v
                                              },
                                              expression: "buscarAccion"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c("br"),
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { md12: "" } },
                                        [
                                          _c(
                                            "v-card",
                                            [
                                              _c("ag-grid-vue", {
                                                staticClass:
                                                  "ag-theme-material",
                                                staticStyle: {
                                                  width: "100%",
                                                  height: "380px",
                                                  "font-family":
                                                    "'Asap', sans-serif"
                                                },
                                                attrs: {
                                                  columnDefs:
                                                    _vm.columnDefsAcciones,
                                                  rowData: _vm.AccionesRespaldo,
                                                  rowSelection: "multiple",
                                                  rowMultiSelectWithClick:
                                                    "false",
                                                  pagination: "true",
                                                  paginationPageSize: "10",
                                                  suppressRowClickSelection:
                                                    "true",
                                                  suppressCopyRowsToClipboard:
                                                    "true",
                                                  sideBar: false,
                                                  localeText: _vm.localeText,
                                                  onGridReady:
                                                    _vm.onGridReadyAccionesEditar,
                                                  postProcessPopup:
                                                    _vm.onClickCell,
                                                  processCellForClipboard:
                                                    _vm.procesarFecha,
                                                  suppressCsvExport: true,
                                                  suppressExcelExport: true,
                                                  getRowNodeId:
                                                    _vm.getRowNodeIdAccion,
                                                  singleClickEdit: true,
                                                  isExternalFilterPresent:
                                                    _vm.isExternalFilterPresentAcciones,
                                                  doesExternalFilterPass:
                                                    _vm.doesExternalFilterPassAcciones
                                                },
                                                on: {
                                                  "selection-changed": function(
                                                    $event
                                                  ) {
                                                    return _vm.onSelectionChangedAcciones(
                                                      $event
                                                    )
                                                  },
                                                  "row-selected": function(
                                                    $event
                                                  ) {
                                                    return _vm.onRowSelectedAccion(
                                                      $event
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.bottomNav == _vm.asociarSubAcciones.step &&
                            ((_vm.asociarSubAcciones.visible &&
                              _vm.esEdicion) ||
                              (_vm.asociarSubAccionesVerDetalle.visible &&
                                !_vm.esEdicion)),
                          expression:
                            "\n            bottomNav == asociarSubAcciones.step &&\n              ((asociarSubAcciones.visible && esEdicion) ||\n                (asociarSubAccionesVerDetalle.visible && !esEdicion))\n          "
                        }
                      ],
                      staticClass: "cardnew",
                      attrs: { align: "center" }
                    },
                    [
                      _c("br"),
                      _c(
                        "v-flex",
                        { attrs: { md10: "" } },
                        [
                          _c(
                            "v-card",
                            { staticClass: "rounded-card" },
                            [
                              _c(
                                "v-container",
                                {
                                  attrs: {
                                    "grid-list-md": "",
                                    "text-xs-center": ""
                                  }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c(
                                        "div",
                                        { attrs: { align: "left" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { md12: "" } },
                                            [
                                              _c(
                                                "h2",
                                                { staticClass: "h2_title" },
                                                [_vm._v("Asociar Subacciones")]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _c("v-divider"),
                                  _c("br"),
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { md6: "" } },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              items: _vm.AccionesPadreCheck,
                                              label: "Acciones",
                                              "item-value": "accionId",
                                              "item-text": "nombre",
                                              "no-data-text": "Sin resultados"
                                            },
                                            on: {
                                              change:
                                                _vm.accionesAsignadasChange
                                            },
                                            model: {
                                              value: _vm.AccionPadreId,
                                              callback: function($$v) {
                                                _vm.AccionPadreId = $$v
                                              },
                                              expression: "AccionPadreId"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-flex",
                                        { attrs: { md6: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Buscar...",
                                              "prepend-icon": "lock_open",
                                              "append-icon": "search"
                                            },
                                            on: {
                                              input:
                                                _vm.onFilterTextBoxChangedSubAcciones
                                            },
                                            model: {
                                              value: _vm.buscarSubAccion,
                                              callback: function($$v) {
                                                _vm.buscarSubAccion = $$v
                                              },
                                              expression: "buscarSubAccion"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c("br"),
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { md12: "" } },
                                        [
                                          _c(
                                            "v-card",
                                            [
                                              _c("ag-grid-vue", {
                                                staticClass:
                                                  "ag-theme-material",
                                                staticStyle: {
                                                  width: "100%",
                                                  height: "380px",
                                                  "font-family":
                                                    "'Asap', sans-serif"
                                                },
                                                attrs: {
                                                  columnDefs:
                                                    _vm.columnDefsSubAcciones,
                                                  rowData:
                                                    _vm.SubAccionesRespaldo,
                                                  rowSelection: "multiple",
                                                  rowMultiSelectWithClick:
                                                    "false",
                                                  pagination: "true",
                                                  paginationPageSize: "10",
                                                  suppressRowClickSelection:
                                                    "true",
                                                  suppressCopyRowsToClipboard:
                                                    "true",
                                                  sideBar: false,
                                                  localeText: _vm.localeText,
                                                  onGridReady:
                                                    _vm.onGridReadySubAccionesEditar,
                                                  postProcessPopup:
                                                    _vm.onClickCell,
                                                  processCellForClipboard:
                                                    _vm.procesarFecha,
                                                  suppressCsvExport: true,
                                                  suppressExcelExport: true,
                                                  getRowNodeId:
                                                    _vm.getRowNodeIdSubAccion,
                                                  isExternalFilterPresent:
                                                    _vm.isExternalFilterPresentSubAcciones,
                                                  doesExternalFilterPass:
                                                    _vm.doesExternalFilterPassSubAcciones
                                                },
                                                on: {
                                                  "selection-changed": function(
                                                    $event
                                                  ) {
                                                    return _vm.onSelectionChangedSubAccion(
                                                      $event
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacion,
          titulo: _vm.$t("mensajes.crud.editar.titulo", {
            entidad: "Módulo",
            nombreEntidad: this.editedItem.nombre
          }),
          mensaje: _vm.mensajeConfirmacion,
          textoBtnSi: _vm.$t("mensajes.crud.editar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.editar.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallback($event)
          }
        }
      }),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacionClose,
          titulo: _vm.$t("mensajes.mensajesAbandono.editar.titulo"),
          mensaje: _vm.$t("mensajes.mensajesAbandono.editar.mensaje"),
          textoBtnSi: _vm.$t("mensajes.mensajesAbandono.editar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.mensajesAbandono.editar.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallbackConfirm($event, false)
          }
        }
      }),
      _c(
        "div",
        { staticClass: "text-xs-center" },
        [
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": 400 },
              model: {
                value: _vm.showAlertaSinSubAcciones,
                callback: function($$v) {
                  _vm.showAlertaSinSubAcciones = $$v
                },
                expression: "showAlertaSinSubAcciones"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    { attrs: { dark: "", color: "primary" } },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticStyle: {
                            "font-size": "17px",
                            "margin-left": "10px !important"
                          }
                        },
                        [_vm._v("Seleccionar Subacciones")]
                      )
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c("v-card-text", [
                    _vm._v("Debe seleccionar al menos una Subacción por Acción")
                  ]),
                  _c("v-divider"),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "#526da5", small: "" },
                          on: {
                            click: function($event) {
                              return _vm.confirmCallbackSinSubAcciones()
                            }
                          }
                        },
                        [
                          _c("span", { staticStyle: { color: "white" } }, [
                            _vm._v("Aceptar")
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }